const getMediaUrl = (key, isAudio, voice = 'MALE') => {
  const awsBaseUrl = process.env.REACT_APP_AWS_BASE_URL.replace(/\/+$/, '');

  if (!key) return undefined;
  return isAudio
    ? `${awsBaseUrl}/AUDIO/${voice}${key}`
    : `${awsBaseUrl}/IMAGE${key}`;
};

export default getMediaUrl;
